/* Mobile menu burger toggle */
(function () {
    const navigation = document.querySelector('.gh-navigation');
    const burger = navigation.querySelector('.gh-burger');
    if (!burger) return;

    burger.addEventListener('click', function () {
        if (!navigation.classList.contains('is-open')) {
            navigation.classList.add('is-open');
            document.documentElement.style.overflowY = 'hidden';
        } else {
            navigation.classList.remove('is-open');
            document.documentElement.style.overflowY = null;
        }
    });
})();

/* Add lightbox to gallery images */
(function () {
    lightbox(
        '.kg-image-card > .kg-image[width][height], .kg-gallery-image > img'
    );
})();

/* Responsive video in post content */
(function () {
    const sources = [
        '.gh-content iframe[src*="youtube.com"]',
        '.gh-content iframe[src*="youtube-nocookie.com"]',
        '.gh-content iframe[src*="player.vimeo.com"]',
        '.gh-content iframe[src*="kickstarter.com"][src*="video.html"]',
        '.gh-content object',
        '.gh-content embed',
    ];
    reframe(document.querySelectorAll(sources.join(',')));
})();

/* Turn the main nav into dropdown menu when there are more than 5 menu items */
(function () {
    dropdown();
})();

/* Infinite scroll pagination */
(function () {
    if (!document.body.classList.contains('home-template') && !document.body.classList.contains('post-template')) {
        pagination();
    }
})();

/* NEW badge for recent posts (< 14 days old) */
(function () {
    const cards = document.querySelectorAll('.gh-card');
    const cutoff = Date.now() - 14 * 24 * 60 * 60 * 1000;

    cards.forEach(function (card) {
        var time = card.querySelector('.gh-card-date');
        var badge = card.querySelector('.gh-card-new');
        if (!time || !badge) return;

        var published = new Date(time.getAttribute('datetime'));
        if (published.getTime() > cutoff) {
            badge.removeAttribute('hidden');
        }
    });
})();

/* Horizontal scroller: edge fades + prev/next arrow controls */
(function () {
    const sections = document.querySelectorAll('.gh-container.is-scroller');
    if (!sections.length) return;

    const chevron = function (dir) {
        return '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
            (dir === 'prev' ? '<polyline points="15 18 9 12 15 6"></polyline>' : '<polyline points="9 18 15 12 9 6"></polyline>') +
            '</svg>';
    };

    sections.forEach(function (section) {
        const wrapper = section.querySelector('.gh-main');
        const feed = section.querySelector('.gh-scroller-feed');
        const inner = section.querySelector('.gh-container-inner');
        if (!wrapper || !feed || !inner) return;

        const controls = document.createElement('div');
        controls.className = 'gh-scroller-controls';

        const prevBtn = document.createElement('button');
        prevBtn.type = 'button';
        prevBtn.className = 'gh-scroller-btn is-prev';
        prevBtn.setAttribute('aria-label', 'Scroll left');
        prevBtn.innerHTML = chevron('prev');

        const nextBtn = document.createElement('button');
        nextBtn.type = 'button';
        nextBtn.className = 'gh-scroller-btn is-next';
        nextBtn.setAttribute('aria-label', 'Scroll right');
        nextBtn.innerHTML = chevron('next');

        controls.appendChild(prevBtn);
        controls.appendChild(nextBtn);
        inner.appendChild(controls);

        const step = function () {
            const card = feed.querySelector('.gh-card');
            const cardWidth = card ? card.getBoundingClientRect().width : feed.clientWidth * 0.8;
            return cardWidth + 42;
        };

        const update = function () {
            const maxScroll = feed.scrollWidth - feed.clientWidth;
            const atStart = feed.scrollLeft <= 1;
            const atEnd = feed.scrollLeft >= maxScroll - 1;
            wrapper.classList.toggle('can-scroll-left', !atStart);
            wrapper.classList.toggle('can-scroll-right', !atEnd);
            prevBtn.disabled = atStart;
            nextBtn.disabled = atEnd;
            controls.hidden = maxScroll <= 1;
        };

        prevBtn.addEventListener('click', function () {
            feed.scrollBy({ left: -step(), behavior: 'smooth' });
        });
        nextBtn.addEventListener('click', function () {
            feed.scrollBy({ left: step(), behavior: 'smooth' });
        });

        feed.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', update);
        update();
    });
})();

/* Responsive HTML table */
(function () {
    const tables = document.querySelectorAll('.gh-content > table:not(.gist table)');
    
    tables.forEach(function (table) {
        const wrapper = document.createElement('div');
        wrapper.className = 'gh-table';
        table.parentNode.insertBefore(wrapper, table);
        wrapper.appendChild(table);
    });
})();